module.exports = __webpack_public_path__ + "img/logo-emb.77525aa6.png";